
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/airlines/reviews/[id]",
      function () {
        return require("private-next-pages/airlines/reviews/[id].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/airlines/reviews/[id]"])
      });
    }
  